(function () {
  'use strict';

  function initHeaderScroll() {
    var header = document.querySelector('.header');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }
  function getOverlay() { return document.getElementById('CartDrawer-Overlay'); }

  function openCart() {
    var drawer = getDrawer();
    var overlay = getOverlay();
    if (!drawer) return false;
    drawer.classList.add('is-open');
    if (overlay) {
      overlay.hidden = false;
      overlay.style.display = 'block';
    }
    document.body.style.overflow = 'hidden';
    return true;
  }

  function closeCart() {
    var drawer = getDrawer();
    var overlay = getOverlay();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) {
      overlay.hidden = true;
      overlay.style.display = 'none';
    }
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    // Delegated, so it keeps working after the drawer is refreshed.
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn && getDrawer()) {
        e.preventDefault();
        openCart();
        return;
      }
      if (e.target.closest('[data-cart-close]') || e.target.id === 'CartDrawer-Overlay') {
        closeCart();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });
  }

  // Add to cart from product cards without leaving the page.
  // Falls back to the normal form post if anything goes wrong.
  function refreshCartUI() {
    return fetch('/cart', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector('[data-cart-drawer]');
        var drawer = getDrawer();
        if (freshDrawer && drawer) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = freshDrawer.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
        }
        var freshBtn = doc.querySelector('[data-cart-open]');
        var btn = document.querySelector('[data-cart-open]');
        if (freshBtn && btn) btn.innerHTML = freshBtn.innerHTML;
      });
  }

  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('.product-card form')) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) btn.classList.add('is-adding');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { return refreshCartUI(); })
        .then(function () {
          if (btn) {
            btn.classList.remove('is-adding');
            btn.classList.add('is-added');
            btn.textContent = 'Added';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = label;
            }, 1800);
          }
          openCart();
          toast('Added to cart');
          if (btn) { var br = btn.getBoundingClientRect(); confetti(br.left + br.width / 2, br.top); }
        })
        .catch(function () {
          if (btn) btn.classList.remove('is-adding');
          form.submit();
        });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var main = document.querySelector('[data-gallery-main]');
        if (!main || !src) return;
        main.src = src;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  function initQty() {
    document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input[type="number"]');
        if (input) {
          input.value = Math.max(1, parseInt(input.value, 10) - 1);
        }
      });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input[type="number"]');
        if (input) {
          input.value = parseInt(input.value, 10) + 1;
        }
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item') || btn.closest('.pp-accordion__item');
        if (!item) return;
        var group = item.parentElement;
        var wasOpen = item.classList.contains('is-open');
        if (group) {
          group.querySelectorAll('.is-open').forEach(function (el) {
            el.classList.remove('is-open');
          });
        }
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    function onScroll() {
      btn.classList.toggle('is-visible', window.scrollY > 500);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  }


  /* ---------- Motion system (v2) ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.reveal, .stagger');
    if (!els.length) return;
    els.forEach(function (el) {
      if (el.classList.contains('stagger')) {
        Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--n', Math.min(i, 12)); });
      }
    });
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initScrollProgress() {
    var bar = document.querySelector('[data-scroll-progress]');
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initHeaderHide() {
    var header = document.querySelector('.header');
    if (!header) return;
    var last = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var menuOpen = document.querySelector('[data-mobile-menu].is-open');
      header.classList.toggle('is-hidden', y > last && y > 240 && !menuOpen);
      last = y;
    }, { passive: true });
  }

  function initImageFade() {
    document.querySelectorAll('main img[loading="lazy"], .product-card__image, .category-card__image').forEach(function (img) {
      if (img.complete && img.naturalWidth) return;
      img.classList.add('is-loading');
      function done() { img.classList.remove('is-loading'); img.classList.add('is-loaded'); }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', function () { img.classList.remove('is-loading'); }, { once: true });
    });
  }

  function initSpotlight() {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.category-card, .product-card__media, .why-card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  function initTilt() {
    if (reduceMotion || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.hero__item').forEach(function (item) {
      var tile = item.querySelector('.hero__tile');
      if (!tile) return;
      item.addEventListener('pointermove', function (e) {
        var r = item.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        tile.style.transform = 'perspective(700px) rotateY(' + (x * 12) + 'deg) rotateX(' + (-y * 12) + 'deg) translateY(-8px)';
      });
      item.addEventListener('pointerleave', function () { tile.style.transform = ''; });
    });
  }

  function initRipple() {
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest && e.target.closest('.btn');
      if (!btn || reduceMotion) return;
      var r = btn.getBoundingClientRect();
      var size = Math.max(r.width, r.height);
      var dot = document.createElement('span');
      dot.className = 'ripple';
      dot.style.width = dot.style.height = size + 'px';
      dot.style.left = (e.clientX - r.left - size / 2) + 'px';
      dot.style.top = (e.clientY - r.top - size / 2) + 'px';
      btn.appendChild(dot);
      setTimeout(function () { dot.remove(); }, 650);
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('.stats-bar__value');
    if (!els.length || !('IntersectionObserver' in window) || reduceMotion) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var text = el.textContent.trim();
        var m = text.match(/^([^\d]*)([\d,.]+)(.*)$/);
        if (!m) return;
        var target = parseFloat(m[2].replace(/,/g, ''));
        if (!isFinite(target)) return;
        var decimals = (m[2].split('.')[1] || '').length;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / 1100, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var v = (target * eased).toFixed(decimals);
          el.textContent = m[1] + (m[2].indexOf(',') > -1 ? Number(v).toLocaleString('en-US') : v) + m[3];
          if (p < 1) requestAnimationFrame(step); else el.textContent = text;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCartBump() {
    var obs = document.querySelector('.header__cart-count');
    if (!obs || !window.MutationObserver) return;
    new MutationObserver(function () {
      obs.classList.add('is-bump');
      setTimeout(function () { obs.classList.remove('is-bump'); }, 260);
    }).observe(obs, { childList: true, characterData: true, subtree: true });
  }


  /* ---------- v6: loader, cursor, wishlist, toast, confetti, recent ---------- */
  function toast(msg) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('is-show'); }, 2200);
  }
  window.nexToast = toast;

  function confetti(x, y) {
    if (reduceMotion) return;
    var colors = ['#6A3DF5', '#FF3D6E', '#C6FF3D', '#FFB800', '#120A2B'];
    for (var i = 0; i < 26; i++) {
      var p = document.createElement('i');
      p.className = 'confetti';
      var ang = Math.random() * Math.PI * 2, dist = 60 + Math.random() * 120;
      p.style.left = x + 'px'; p.style.top = y + 'px';
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
      p.style.setProperty('--dy', Math.sin(ang) * dist - 60 + 'px');
      p.style.setProperty('--rot', (Math.random() * 720 - 360) + 'deg');
      document.body.appendChild(p);
      setTimeout(function (el) { el.remove(); }.bind(null, p), 1100);
    }
  }
  window.nexConfetti = confetti;

  function initLoader() {
    var l = document.querySelector('[data-loader]');
    if (!l) return;
    function hide() { l.classList.add('is-done'); setTimeout(function () { l.remove(); }, 700); }
    if (sessionStorageSafe('get') === '1') { l.remove(); return; }
    sessionStorageSafe('set');
    setTimeout(hide, reduceMotion ? 0 : 650);
  }
  function sessionStorageSafe(mode) {
    try {
      if (mode === 'set') sessionStorage.setItem('nex-loaded', '1');
      else return sessionStorage.getItem('nex-loaded');
    } catch (e) { return null; }
  }

  function initCursor() {
    var dot = document.querySelector('[data-cursor]');
    if (!dot || reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var x = 0, y = 0, cx = 0, cy = 0, on = false;
    document.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!on) { on = true; dot.classList.add('is-on'); requestAnimationFrame(loop); }
      dot.classList.toggle('is-link', !!(e.target.closest && e.target.closest('a, button, .btn, input, select, label')));
    }, { passive: true });
    function loop() {
      cx += (x - cx) * 0.2; cy += (y - cy) * 0.2;
      dot.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      requestAnimationFrame(loop);
    }
  }

  function getWish() { try { return JSON.parse(localStorage.getItem('nex-wish') || '[]'); } catch (e) { return []; } }
  function setWish(a) { try { localStorage.setItem('nex-wish', JSON.stringify(a)); } catch (e) {} }
  function initWishlist() {
    var saved = getWish();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      if (saved.indexOf(b.getAttribute('data-wish')) > -1) { b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); }
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-wish]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-wish'), list = getWish(), i = list.indexOf(h);
      if (i > -1) { list.splice(i, 1); b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); toast('Removed from saved'); }
      else {
        list.push(h); b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); toast('Saved for later');
        var r = b.getBoundingClientRect(); confetti(r.left + r.width / 2, r.top + r.height / 2);
      }
      setWish(list);
    });
  }

  function initRecent() {
    var cur = document.querySelector('[data-recent-current]');
    var wrap = document.querySelector('[data-recent]');
    var key = 'nex-recent', list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    if (cur && wrap) {
      var c; try { c = JSON.parse(cur.textContent); } catch (e) { c = null; }
      if (c) {
        var others = list.filter(function (p) { return p.handle !== c.handle; });
        var row = wrap.querySelector('[data-recent-row]');
        if (others.length && row) {
          others.slice(0, 4).forEach(function (p) {
            var a = document.createElement('a');
            a.className = 'recent__item'; a.href = p.url;
            var img = document.createElement('img'); img.src = p.image || ''; img.alt = ''; img.loading = 'lazy';
            var t = document.createElement('span'); t.textContent = p.title;
            var pr = document.createElement('b'); pr.textContent = p.price;
            a.appendChild(img); a.appendChild(t); a.appendChild(pr); row.appendChild(a);
          });
          wrap.hidden = false;
        }
        list = [c].concat(others).slice(0, 8);
        try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
      }
    }
  }

  function initParallax() {
    if (reduceMotion) return;
    var hero = document.querySelector('.hero');
    if (!hero) return;
    window.addEventListener('scroll', function () {
      var y = Math.min(window.scrollY, 800);
      hero.style.setProperty('--py', (y * 0.12) + 'px');
    }, { passive: true });
  }

  function initMagnetic() {
    if (reduceMotion || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.hero .btn, .newsletter .btn').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.translate = ((e.clientX - r.left - r.width / 2) * 0.18) + 'px ' + ((e.clientY - r.top - r.height / 2) * 0.28) + 'px';
      });
      b.addEventListener('pointerleave', function () { b.style.translate = ''; });
    });
  }

  function initHeroWords() {
    var t = document.querySelector('.hero__title');
    if (!t || reduceMotion || t.dataset.split) return;
    t.dataset.split = '1';
    var n = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
            var sp = document.createElement('span');
            sp.className = 'word'; sp.style.setProperty('--w', n++);
            sp.textContent = w; frag.appendChild(sp);
          });
          c.parentNode.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.tagName !== 'BR') walk(c);
      });
    })(t);
  }


  /* ---------- v7: swipe gallery, hover zoom, tab bar ---------- */
  function initSwipeGallery() {
    document.querySelectorAll('[data-swipe-gallery]').forEach(function (g) {
      var track = g.querySelector('[data-swipe-track]');
      if (!track) return;
      var slides = track.querySelectorAll('[data-swipe-slide]');
      var thumbs = g.querySelectorAll('[data-swipe-thumb]');
      var dots = g.querySelectorAll('.pp-gallery__dot');
      var count = g.querySelector('[data-swipe-count]');
      var current = 0;
      function setActive(i) {
        current = i;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        // scroll only the carousel, never the page
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(i);
      }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-swipe-thumb'), 10)); }); });
      var prev = g.querySelector('[data-swipe-prev]'), next = g.querySelector('[data-swipe-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });
      // desktop: hover to zoom
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduceMotion) {
        slides.forEach(function (sl) {
          var img = sl.querySelector('img');
          sl.addEventListener('pointermove', function (e) {
            var r = sl.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
            img.classList.add('is-zoomed');
          });
          sl.addEventListener('pointerleave', function () { img.classList.remove('is-zoomed'); });
        });
      }
    });
  }


  function initDrop() {
    var el = document.querySelector('[data-drop-date]');
    if (!el) return;
    var raw = el.getAttribute('data-drop-date').trim().replace(' ', 'T');
    var end = new Date(raw).getTime();
    if (!isFinite(end)) { el.hidden = true; return; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.hidden = true; clearInterval(timer); return; }
      el.querySelector('[data-d]').textContent = pad(Math.floor(d / 864e5));
      el.querySelector('[data-h]').textContent = pad(Math.floor(d % 864e5 / 36e5));
      el.querySelector('[data-m]').textContent = pad(Math.floor(d % 36e5 / 6e4));
      el.querySelector('[data-s]').textContent = pad(Math.floor(d % 6e4 / 1e3));
    }
    var timer = setInterval(tick, 1000); tick();
  }


  function initTabbarToggle() {
    var btn = document.querySelector('[data-tabbar-toggle]');
    var bar = document.querySelector('[data-tabbar]');
    if (!btn || !bar) return;
    var label = btn.querySelector('[data-tabbar-toggle-label]');
    function apply(hidden) {
      document.body.classList.toggle('tabbar-hidden', hidden);
      btn.setAttribute('aria-expanded', hidden ? 'false' : 'true');
      btn.setAttribute('aria-label', hidden ? 'Show bottom menu' : 'Hide bottom menu');
      if (label) label.textContent = hidden ? 'Menu' : 'Hide menu';
      bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      if (hidden) bar.setAttribute('inert', ''); else bar.removeAttribute('inert');
    }
    var saved = false;
    try { saved = localStorage.getItem('nex-tabbar-hidden') === '1'; } catch (e) {}
    apply(saved);
    btn.addEventListener('click', function () {
      var hidden = !document.body.classList.contains('tabbar-hidden');
      apply(hidden);
      try { localStorage.setItem('nex-tabbar-hidden', hidden ? '1' : '0'); } catch (e) {}
    });
  }


  function initSocialVideos() {
    document.querySelectorAll('[data-sv]').forEach(function (root) {
      var track = root.querySelector('[data-sv-track]');
      var modal = root.querySelector('[data-sv-modal]');
      var stage = root.querySelector('[data-sv-stage]');
      var lastFocus = null;
      function step(dir) {
        var card = track.querySelector('.sv-card');
        var w = card ? card.getBoundingClientRect().width + 16 : 260;
        track.scrollBy({ left: dir * w * 1.5, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      var prev = root.querySelector('[data-sv-prev]'), next = root.querySelector('[data-sv-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      // clips autoplay muted while on screen; the play button hides while they play
      var vids = track.querySelectorAll('[data-sv-preview]');
      vids.forEach(function (v) {
        var media = v.closest('.sv-card__media');
        v.addEventListener('playing', function () { if (media) media.classList.add('is-playing'); });
        v.addEventListener('pause', function () { if (media) media.classList.remove('is-playing'); });
      });
      if (vids.length && 'IntersectionObserver' in window && !reduceMotion) {
        var ioV = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && e.intersectionRatio > 0.6) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else v.pause();
          });
        }, { threshold: [0, 0.6] });
        vids.forEach(function (v) { ioV.observe(v); });
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        stage.innerHTML = '';
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }
      function openModal(btn) {
        var type = btn.getAttribute('data-type');
        var id = btn.getAttribute('data-id');
        var src = btn.getAttribute('data-src');
        var el;
        if (type === 'youtube' && id) {
          el = document.createElement('iframe');
          el.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
          el.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          el.allowFullscreen = true;
        } else if (type === 'vimeo' && id) {
          el = document.createElement('iframe');
          el.src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
          el.allow = 'autoplay; fullscreen; picture-in-picture';
          el.allowFullscreen = true;
        } else if (type === 'tiktok' && id) {
          el = document.createElement('iframe');
          el.src = 'https://www.tiktok.com/embed/v2/' + encodeURIComponent(id);
          el.allow = 'autoplay; fullscreen; encrypted-media'; el.allowFullscreen = true;
        } else if (type === 'instagram' && id) {
          el = document.createElement('iframe');
          el.src = 'https://www.instagram.com/p/' + encodeURIComponent(id) + '/embed';
          el.allow = 'autoplay; fullscreen; encrypted-media'; el.allowFullscreen = true;
        } else if ((type === 'tiktok' || type === 'instagram' || type === 'link') && btn.getAttribute('data-url')) {
          window.open(btn.getAttribute('data-url'), '_blank', 'noopener');
          return;
        } else if (type === 'file' && src) {
          el = document.createElement('video');
          el.src = src; el.controls = true; el.autoplay = true; el.playsInline = true; el.loop = true;
        } else return;
        el.className = 'sv-modal__media';
        stage.innerHTML = '';
        stage.appendChild(el);
        lastFocus = btn;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var c = modal.querySelector('.sv-modal__close'); if (c) c.focus();
      }
      track.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sv-open]');
        if (b) openModal(b);
      });
      root.addEventListener('click', function (e) { if (e.target.closest('[data-sv-close]')) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    });
  }


  /* ---------- v12: card tilt, page fade, cart shake ---------- */
  function initCardTilt() {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.product-card__media').forEach(function (m) {
      m.addEventListener('pointermove', function (e) {
        var r = m.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        m.style.transform = 'perspective(800px) rotateY(' + (x * 7) + 'deg) rotateX(' + (-y * 7) + 'deg) translateY(-4px)';
      });
      m.addEventListener('pointerleave', function () { m.style.transform = ''; });
    });
  }

  function initPageFade() {
    if (reduceMotion) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (a.target && a.target !== '_self') return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/.test(href)) return;
      if (a.hostname !== window.location.hostname) return;
      if (a.hasAttribute('data-cart-open') || a.hasAttribute('download')) return;
      document.body.classList.add('is-leaving');
    });
    window.addEventListener('pageshow', function () { document.body.classList.remove('is-leaving'); });
  }

  function initCartShake() {
    document.addEventListener('submit', function (e) {
      if (!e.target.matches || !e.target.matches('.product-card form, #ProductForm')) return;
      var c = document.querySelector('.header__icon-btn[data-cart-open], [data-cart-open]');
      if (!c) return;
      c.classList.remove('is-shake'); void c.offsetWidth; c.classList.add('is-shake');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderScroll();
    initMobileMenu();
    initCartDrawer();
    initQuickAdd();
    initGallery();
    initQty();
    initFaq();
    initBackToTop();
    initReveal();
    initScrollProgress();
    initHeaderHide();
    initImageFade();
    initSpotlight();
    initTilt();
    initRipple();
    initCountUp();
    initCartBump();
    initLoader();
    initCursor();
    initRecent();
    initParallax();
    initMagnetic();
    initSwipeGallery();
    initDrop();
    initTabbarToggle();
    initSocialVideos();
    initCardTilt();
    initPageFade();
    initCartShake();
    initHeroWords();
  });
})();
